import { IconMessageCog, IconReceiptRefund, IconReportMoney, IconSwords } from "@tabler/icons-react";
import { type ComponentType, createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const MatchesPage = lazy(() => import("./MatchesPage").then((m) => ({ default: m.MatchesPage })));
const MatchDetailPage = lazy(() => import("./MatchDetailPage").then((m) => ({ default: m.MatchDetailPage })));
const SettlementsPage = lazy(() => import("./SettlementsPage").then((m) => ({ default: m.SettlementsPage })));
const SettingsPage = lazy(() => import("./SettingsPage").then((m) => ({ default: m.SettingsPage })));
const ReportPage = lazy(() => import("./ReportPage").then((m) => ({ default: m.ReportPage })));

const el = <P extends object>(c: ComponentType<P>, props: P) =>
  createElement(Suspense, { fallback: null }, createElement(c, props));

export const routes: FeatureRoute[] = [
  { path: "/admin/p2p", roles: CAPS.admin.p2p, element: el(MatchesPage, { surface: "admin" }) },
  { path: "/admin/p2p/settlements", roles: CAPS.admin.p2p, element: el(SettlementsPage, {}) },
  { path: "/admin/p2p/report", roles: CAPS.admin.p2p, element: el(ReportPage, { surface: "admin" }) },
  { path: "/admin/p2p/:matchId", roles: CAPS.admin.p2p, element: el(MatchDetailPage, { surface: "admin" }) },
  { path: "/portal/p2p", roles: CAPS.portal.p2p, element: el(MatchesPage, { surface: "portal" }) },
  { path: "/portal/p2p/report", roles: CAPS.portal.p2p, element: el(ReportPage, { surface: "portal" }) },
  { path: "/portal/p2p/settings", roles: CAPS.portal.p2p, element: el(SettingsPage, {}) },
  { path: "/portal/p2p/:matchId", roles: CAPS.portal.p2p, element: el(MatchDetailPage, { surface: "portal" }) },
];

export const nav: NavItem[] = [
  { label: "Duels", path: "/admin/p2p", icon: IconSwords, surface: "admin", roles: CAPS.admin.p2p },
  {
    label: "Duel settlements",
    path: "/admin/p2p/settlements",
    icon: IconReceiptRefund,
    surface: "admin",
    roles: CAPS.admin.p2p,
  },
  { label: "Duel report", path: "/admin/p2p/report", icon: IconReportMoney, surface: "admin", roles: CAPS.admin.p2p },
  { label: "Duels", path: "/portal/p2p", icon: IconSwords, surface: "portal", roles: CAPS.portal.p2p },
  {
    label: "Duel report",
    path: "/portal/p2p/report",
    icon: IconReportMoney,
    surface: "portal",
    roles: CAPS.portal.p2p,
  },
  {
    label: "Duel settings",
    path: "/portal/p2p/settings",
    icon: IconMessageCog,
    surface: "portal",
    roles: CAPS.portal.p2p,
  },
];
